/**
 * Utility per gestire gli URL delle immagini dal backend
 */

// URL base Cloudinary senza trasformazioni
const CLOUDINARY_BASE = 'https://res.cloudinary.com/divinea/image/upload/';
const CLOUDINARY_STORE_PATH = 'v1/production/store/';

// URL base per le immagini piccole (card, liste)
export const CLOUDINARY_IMAGE_BASE_URL = `${CLOUDINARY_BASE}c_fill,w_500,h_500/${CLOUDINARY_STORE_PATH}`;

// URL base per le immagini grandi (pagina dettaglio, fullscreen)
export const CLOUDINARY_IMAGE_LARGE_URL = `${CLOUDINARY_BASE}c_fill,h_400,w_900,q_auto,f_auto,dpr_auto/${CLOUDINARY_STORE_PATH}`;

/**
 * Costruisce l'URL completo per un'immagine dal backend
 * @param mediaUrl URL relativo dell'immagine (es: "okuzivtkxs6ncjvtbdfh.png")
 * @param large Se true, usa h_900 per immagini grandi (default: false, usa h_500)
 * @returns URL completo per l'immagine
 */
export function getImageUrl(mediaUrl: string | undefined | null, large: boolean = false): string {
  if (!mediaUrl) {
    return 'https://res.cloudinary.com/divinea/image/upload/v1/production/cache/lgdkpct7hn0skbfbupgi.jpg';
  }

  // Se l'URL è già completo (inizia con http:// o https://), restituiscilo così com'è
  if (mediaUrl.startsWith('http://') || mediaUrl.startsWith('https://')) {
    return mediaUrl;
  }

  // Scegli l'URL base in base alla dimensione richiesta
  const baseUrl = large ? CLOUDINARY_IMAGE_LARGE_URL : CLOUDINARY_IMAGE_BASE_URL;
  
  // Costruisci l'URL completo
  return `${baseUrl}${mediaUrl}`;
}


/** Immagine mostrata quando nessuna delle URL candidate è raggiungibile */
export const PLACEHOLDER_IMAGE_URL = getImageUrl(null);

/**
 * Candidati per una URL Cloudinary, nello stesso ordine del widget:
 * 1. senza il segmento legacy `production/store` (path canonico B2C)
 * 2. con `production/store` (media storici della piattaforma precedente)
 * URL non Cloudinary o senza `/v1/` restituite invariate.
 */
export function getImageUrlCandidates(url: string | undefined | null): string[] {
  if (!url) {
    return [];
  }
  const withoutStore = url.replace(/\/production\/store\//g, '/');
  const withStore = withoutStore.includes('/v1/')
    ? withoutStore.replace('/v1/', '/v1/production/store/')
    : withoutStore;
  return Array.from(new Set([withoutStore, withStore, url]));
}
